import { Modal } from 'antd';

export const rxWithoutLatestDraft = (
    onOk: () => void,
    onCancel: () => void,
    message?: string,
): void => {
    const t = Modal.confirm({
        title: "This prescription doesn't contain latest draft.",
        content: message || 'Do you want to apply and review latest draft before saving?',
        okButtonProps: { className: 'primary-btn font-lato' },
        cancelButtonProps: { className: 'neutral-btn font-lato' },
        okText: 'Yes',
        cancelText: 'No',
        onCancel: () => {
            t.destroy();
            onCancel();
        },
        onOk: async () => {
            t.update({
                okButtonProps: { loading: true },
            });
            onOk();
            t.destroy();
        },
    });
};
